module.exports = __webpack_public_path__ + "img/partner-bg.02d19d5e.webp";